import { createSlice } from "@reduxjs/toolkit";
import { fetchSwitchPharmacy } from "../../apis/pharmacy/switchPharmacy";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const switchPharmacySlice = createSlice({
    name: 'fetchSwitchPharmacy',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(fetchSwitchPharmacy.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(fetchSwitchPharmacy.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(fetchSwitchPharmacy.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default switchPharmacySlice.reducer